import { useMemo, useContext } from 'react'
import AppContext from 'context/appContext'

export function useClientsToImport() {
  const { clientsData } = useContext(AppContext)

  const clientsToImport = useMemo(() => {
    return clientsData?.clients ? clientsData.clients.filter(client => client.created_at === null) : []
  }, [clientsData])

  return {
    clientsToImport,
  }
}
